export default {
  'pending': '@:terms.enabling@:terms.need',
  'processing': '@:terms.enabling중',
  'success': '@:terms.enabling성공',
  'failure': '@:terms.enabling실패',
  'expired': '@:terms.expired',
}
